import {z} from 'zod';

import {IsoUtcDateTimeSchema, UuidV4Schema} from './common.js';

export const DeploymentEnvironmentSchema = z.enum(['staging', 'production']);

export const InstagramAccountSchema = z.strictObject({
  id: UuidV4Schema,
  environment: DeploymentEnvironmentSchema,
  igUserId: z.string().min(1).nullable(),
  username: z.string().min(1).nullable(),
  accountType: z.literal('BUSINESS').nullable(),
  status: z.enum([
    'unconfigured',
    'disconnected',
    'connecting',
    'active',
    'degraded',
    'paused',
    'reauth_required',
  ]),
  graphVersion: z.string().regex(/^v\d+\.\d+$/u),
});

export type InstagramAccount = z.infer<typeof InstagramAccountSchema>;

export const SecretReferenceSchema = z.strictObject({
  id: UuidV4Schema,
  reference: z.string().min(1),
  purpose: z.string().min(1),
  environment: DeploymentEnvironmentSchema,
  fingerprint: z.string().min(1),
  expiresAt: IsoUtcDateTimeSchema.nullable(),
});

export type SecretReference = z.infer<typeof SecretReferenceSchema>;
